import type { SvgProps } from "replo-utils/react/components";

import * as React from "react";

import { Svg } from "replo-utils/react/components";

const ReferralIconBackground = (props: SvgProps) => (
  <Svg width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
    <g opacity="0.45" filter="url(#filter0_fn_icon)">
      <ellipse
        opacity="0.3"
        cx="8.27141"
        cy="17.5322"
        rx="8.27141"
        ry="17.5322"
        transform="matrix(-0.776851 -0.629684 0.575096 -0.818086 -3.73926 69.4221)"
        fill="#A399FD"
      />
      <ellipse
        cx="7.95546"
        cy="19.9287"
        rx="7.95546"
        ry="19.9287"
        transform="matrix(-0.818991 -0.573807 0.505086 -0.863069 13.8574 67.7017)"
        fill="#DA6AF3"
      />
      <ellipse
        cx="38.784"
        cy="40.0117"
        rx="7.36055"
        ry="17.8109"
        transform="rotate(-124.586 38.784 40.0117)"
        fill="#FFD580"
      />
      <ellipse
        cx="5.78569"
        cy="18.2203"
        rx="5.78569"
        ry="18.2203"
        transform="matrix(-0.846608 -0.532217 0.454085 -0.890958 21.9619 64.3613)"
        fill="#FFD873"
      />
      <ellipse
        cx="30.664"
        cy="25.2287"
        rx="7.569"
        ry="18.319"
        transform="rotate(-124.586 30.664 25.2287)"
        fill="#B7FEAE"
      />
      <ellipse
        cx="13.718"
        cy="40.5774"
        rx="5.94163"
        ry="16.3171"
        transform="rotate(-124.586 13.718 40.5774)"
        fill="#F4408E"
        fillOpacity="0.94"
      />
      <ellipse
        cx="5.84233"
        cy="16.6539"
        rx="5.84233"
        ry="16.6539"
        transform="matrix(0.325917 -0.945399 0.969544 0.244916 -2.61768 33.7842)"
        fill="#EF196E"
      />
    </g>
    <defs>
      <filter
        id="filter0_fn_icon"
        x="-34.3195"
        y="-9.17545"
        width="110.634"
        height="107.73"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="11.1397"
          result="effect1_foregroundBlur_icon"
        />
        <feTurbulence
          type="fractalNoise"
          baseFrequency="14.551181793212891 14.551181793212891"
          stitchTiles="stitch"
          numOctaves={3}
          result="noise"
          seed={3693}
        />
        <feColorMatrix in="noise" type="luminanceToAlpha" result="alphaNoise" />
        <feComponentTransfer in="alphaNoise" result="coloredNoise1">
          <feFuncA
            type="discrete"
            tableValues="1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0"
          />
        </feComponentTransfer>
        <feComposite
          operator="in"
          in2="effect1_foregroundBlur_icon"
          in="coloredNoise1"
          result="noise1Clipped"
        />
        <feFlood floodColor="rgba(255, 255, 255, 0.2)" result="color1Flood" />
        <feComposite
          operator="in"
          in2="noise1Clipped"
          in="color1Flood"
          result="color1"
        />
        <feMerge result="effect2_noise_icon">
          <feMergeNode in="effect1_foregroundBlur_icon" />
          <feMergeNode in="color1" />
        </feMerge>
      </filter>
    </defs>
  </Svg>
);

export default ReferralIconBackground;
